{
  "title": "Create Magen",
  "source": "Icewind Dale - Rime of the Frostmaiden",
  "levelAndSchool": "7th-level transmutation",
  "level": 7,
  "castingTime": "1 hour",
  "range": "Touch",
  "components": "V, S, M (a vial of quicksilver worth 500 gp and a life-sized human doll, both of which the spell consumes, and an intricate crystal rod worth at least 1,500 gp that is not consumed)",
  "duration": "Instantaneous",
  "description": [
    "While casting the spell, you place a vial of quicksilver in the chest of a life-sized human doll stuffed with ash or dust. You then stitch up the doll and drip your blood on it. At the end of the casting, you tap the doll with a crystal rod, transforming it into a magen clothed in whatever the doll was wearing. The type of magen is chosen by you during the casting of the spell.",
    "When the magen appears, your hit point maximum decreases by an amount equal to the magen's challenge rating (minimum reduction of 1). Only a Wish spell can undo this reduction to your hit point maximum.",
    "Any magen you create with this spell obeys your commands without question."
  ],
  "spellLists": ["wizard"]
}
